var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"diff"},_vm._l((_vm.diffParts),function(part,idx){return _c(_vm.getTagName(part),{key:idx,tag:"component",staticClass:"diff-part"},[_vm._v(_vm._s(part.text))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }